import { useEffect, useState } from 'react'

import { authHeader } from '../../api/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

export const useMaintenanceMode = () => {
  const [data, setData] = useState(null)

  useEffect(() => {
    ;(async () => {
      try {
        await refreshToken()

        const url = `${REACT_APP_API_URL}/system/maintenance/mode`
        const options = { method: 'GET', headers: { ...authHeader() } }
        const response = await fetch(url, options)
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const payload = await response.json()
        const mode = Boolean(payload?.data?.is_in_maintenance)
        setData(mode ?? null)
      } catch (error) {
        setData(null)
        console.error('useMaintenanceMode', error)
      }
    })()
  }, [])

  return data
}
